/**
 * assets/bundle-tiers.js
 *
 * Shared tier-selection behaviour for both Bundle & Save widgets (the
 * compact one in the PDP hero and the larger standalone showcase
 * section further down the page). Selecting a tier updates every
 * quantity input on the page (.product-qty / .formQty) so whichever
 * Add to Cart button the shopper clicks submits the right quantity,
 * matching the same sync mechanism theme.js already uses for the
 * regular quantity stepper.
 */
(function () {
  if (window.__bundleTiersLoaded) return;
  window.__bundleTiersLoaded = true;

  function selectTier(container, qty) {
    container.querySelectorAll('[data-bundle-qty]').forEach(function (tier) {
      var isMatch = parseInt(tier.getAttribute('data-bundle-qty'), 10) === qty;
      tier.classList.toggle('is-selected', isMatch);
      tier.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
    });

    document.querySelectorAll('.product-qty, .formQty').forEach(function (input) {
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  document.addEventListener('click', function (event) {
    var tier = event.target.closest('[data-bundle-qty]');
    if (!tier) return;

    var container = tier.closest('[data-bundle-tiers]');
    if (!container) return;

    event.preventDefault();

    var qty = parseInt(tier.getAttribute('data-bundle-qty'), 10);
    selectTier(container, qty);
  });

  document.addEventListener('colourswatch:swapped', function (event) {
    var root = event.detail && event.detail.root;
    if (!root) return;

    var selected = root.querySelector('[data-bundle-qty].is-selected');
    if (selected) {
      var container = selected.closest('[data-bundle-tiers]');
      if (container) selectTier(container, parseInt(selected.getAttribute('data-bundle-qty'), 10));
    }
  });

  // Each [data-bundle-tiers] widget carries its own <script
  // data-bundle-tier-prices> — a per-variant map of already-formatted
  // display strings ("$44.46 each"), computed server-side so the JS
  // side never has to re-implement Liquid's money formatting/discount
  // math. On products with real Shopify variants (e.g. sizes with
  // different prices), theme.js only updates the *displayed* price and
  // the .formVariantId inputs inside the main product section's own
  // context when a size is picked — the standalone Bundle & Save
  // showcase is a separate section outside that context, so both its
  // tier prices and its own hidden variant id went stale on any size
  // other than whichever the page happened to load with. Re-syncing
  // both from a single page-wide listener fixes the showcase the same
  // way the compact hero widget already worked (its tiers/live in the
  // same context/form theme.js updates directly).
  function updateTierPricesForVariant(container, variantId) {
    var pricesScript = container.querySelector('[data-bundle-tier-prices]');
    if (!pricesScript) return;

    var pricesByVariant;
    try {
      pricesByVariant = JSON.parse(pricesScript.textContent);
    } catch (e) {
      return;
    }

    var prices = pricesByVariant[variantId];
    if (!prices) return;

    container.querySelectorAll('[data-bundle-qty]').forEach(function (tier) {
      var qty = tier.getAttribute('data-bundle-qty');
      var priceEl = tier.querySelector('.pdp-bundle__tier-price, .pdp-bundle-save__card-price');
      if (priceEl && prices[qty] != null) {
        priceEl.textContent = prices[qty];
      }
    });
  }

  document.addEventListener('change', function (event) {
    if (!event.target.classList || !event.target.classList.contains('formVariantId')) return;

    var variantId = event.target.value;
    if (!variantId) return;

    document.querySelectorAll('[data-bundle-tiers]').forEach(function (container) {
      updateTierPricesForVariant(container, variantId);
    });

    // Keep every Add to Cart form's hidden variant id in sync too,
    // including ones (like the showcase) outside the section theme.js
    // just updated — otherwise submitting from there adds whichever
    // variant happened to be selected on page load, not the current one.
    document.querySelectorAll('.formVariantId').forEach(function (input) {
      if (input.value !== variantId) input.value = variantId;
    });
  });

  function syncInitialSelection() {
    // Tier 2 ("Most popular") is marked is-selected server-side by default
    // in both widgets, but that only sets the button's own class/aria —
    // it doesn't by itself update the separate .product-qty/.formQty
    // inputs elsewhere in the form. Run the same sync selectTier() does
    // on click, once, so Add to Cart without any interaction still adds
    // the pre-selected quantity instead of the input's raw default of 1.
    document.querySelectorAll('[data-bundle-tiers]').forEach(function (container) {
      var selected = container.querySelector('[data-bundle-qty].is-selected');
      if (selected) {
        selectTier(container, parseInt(selected.getAttribute('data-bundle-qty'), 10));
      }
    });
  }

  document.addEventListener('DOMContentLoaded', syncInitialSelection);
})();
